import { render, staticRenderFns } from "./ToxinsUsed.vue?vue&type=template&id=c62e0f14&"
import script from "./ToxinsUsed.vue?vue&type=script&lang=js&"
export * from "./ToxinsUsed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports